import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";
import "../../PlayDB/AddPlay/style.css";
import { motion } from "framer-motion";
import probingImage from "../../PlayDB/uploads/probing.png";
import { jwtDecode } from 'jwt-decode';
import { Mic ,ArrowRight} from "lucide-react";
import io from "socket.io-client";
import { SOCKET_URL } from "../../Endpoints/Endpoints"; 
import { useLocation } from "react-router-dom";

const CardScenario = () => {
  const [selectedCardGroup, setSelectedCardGroup] = useState(null);
  const [cardGroups, setCardGroups] = useState([]);
  const [cards, setCards] = useState([]);
  const [openedCards, setOpenedCards] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [flippedCardIndex, setFlippedCardIndex] = useState(null);
  const [gameCards, setGameCards] = useState([]); 
  const [gameStarted, setGameStarted] = useState(false); 
  const [userInput, setUserInput] = useState("");
  const [scenario, setscenario] = useState("");
  const [score, setScore] = useState(0);
  const navigate = useNavigate();
  const [gameCategories, setGameCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [gameNames, setGameNames] = useState([]);
  const [loadingNames, setLoadingNames] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [selectedGamename, setSelectedGamename] = useState(null);
  const [timerActive, setTimerActive] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState("");
  const [selectedCardGroups, setSelectedCardGroups] = useState([]); 
  const [isListening, setIsListening] = useState(false);
  const [isFetchingResponse, setIsFetchingResponse] = useState(false);
  const [isFetchingScore, setIsFetchingScore] = useState(false);
  const [showGameOver, setShowGameOver] = useState(false);
  const socket = io(SOCKET_URL, { transports: ["websocket"] }); 
  const [isFetchingAnalysis, setIsFetchingAnalysis] = useState(false);
  const [analysis, setAnalysis] = useState("");
  const location = useLocation();
  const isMultiplayer = location.state?.players?.length > 0;
  const connectedPlayers = location.state?.players || [];
  const [playersData, setPlayersData] = useState([]);
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [showPopup, setShowPopup] = useState(true);
  const [onlineUsers, setOnlineUsers] = useState([]); 
  const [selectedReceiver, setSelectedReceiver] = useState(""); 
  const [karmicAnalysis, setKarmicAnalysis] = useState(false); 
  const [showNotification, setShowNotification] = useState(false);
  const [isFetchingKarmicAnalysis, setIsFetchingKarmicAnalysis] = useState(false);
  const [showKarmicAnalysis, setShowKarmicAnalysis] = useState(false);
  const [isPaused, setIsPaused] = useState(false); 
  ///multiuser///////
  useEffect(() => {
    if (!email) return; 
    socket.on("gameRequest", ({ from }) => {
      console.log("✅ Received game request from:", from, "for:", email);
  
      if (window.confirm(`${from} invited you to play. Accept?`)) {
        socket.emit("respondGameRequest", { from, to: email, accepted: true });
        console.log(`✔️ Sent gameRequest response from ${email} to ${from}`);
      }
    });
  
    return () => {
      socket.off("gameRequest");
    };
  }, [email]); 

useEffect(() => {
  socket.on("updatePlayers", (data) => {
    setPlayersData(data);
  });
  return () => {
    socket.off("updatePlayers");
  };
}, []);

useEffect(() => {
  if (isMultiplayer && (scenario || userInput || response)) {
      socket.emit("playerUpdate", { email, scenario, userInput, response });
  }
}, [isMultiplayer, scenario, userInput, response]);
  
  /////////fetching email//////////
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      const userId = parseInt(decoded.id, 10);
      setUserId(userId);
      localStorage.setItem("id", userId);
      setEmail(decoded.email); 
      console.log("📢 Sending email to backend:", decoded.email);  // ✅ Add this line
      socket.emit("userConnected", decoded.email);
    } else {
    }
  }, []);

  ////////////chatting///////
  useEffect(() => {
    socket.on("chatMessage", ({ sender, text }) => {
        console.log("📥 Received chat message from:", sender, text);

        // Update the opponent’s chat UI
        setMessages((prev) => [...prev, { sender, text }]);
    });

    return () => {
        socket.off("chatMessage");
    };
}, []);

useEffect(() => {
  socket.on("onlineUsers", (users) => {
      console.log("🟢 Online Users:", users);
      setOnlineUsers(users);
  });

  return () => {
      socket.off("onlineUsers");
  };
}, []);

  useEffect(() => {
    if (isMultiplayer && scenario.trim() !== "") {
      setShowPopup(true);
    }
  }, [isMultiplayer, scenario]);

  const handleArrowClick = () => {
    if (scenario.trim() !== "" && selectedReceiver) {
        const formattedMessage = {
            sender: email, 
            receiver: selectedReceiver, 
            text: `Scenario: ${scenario}\n\n And please give the user input for the open card...`,
        };

        console.log("📤 Sending scenario to chat:", formattedMessage);
        socket.emit("chatMessage", formattedMessage); // Send to backend

        // Add message in sender's chat UI
        setMessages((prev) => [...prev, { sender: "You", text: formattedMessage.text }]);

        // Auto-clear scenario after sending
        setscenario("");
    } else {
        alert("Please enter a scenario and select a user.");
    }
};
  
const sendMessage = () => {
  if (newMessage.trim() !== "" && selectedReceiver) {
      const messageData = { sender: email, receiver: selectedReceiver, text: newMessage };

      console.log("📤 Sending message:", messageData);
      socket.emit("chatMessage", messageData); // Send to backend

      setMessages((prev) => [...prev, { sender: "You", text: newMessage }]); // Show in UI
      setNewMessage("");
  } else {
      alert("Please select a user to chat with.");
  }
};
   
  const toggleChat = () => {
    setChatOpen((prev) => !prev);
    console.log("Chat button visibility after toggle:", chatOpen);
  };

  useEffect(() => {
    console.log("Updated Chat button visibility:", chatOpen);
  }, [chatOpen]);  

  ///////////////open ai integration///////////
  const handleFetchScore = async () => {
    const scoreprompt = `show overall score from the following ${response}`; 
    setIsFetchingScore(true);
    const scoreResponse = await sendPromptToAPI(scoreprompt, "score");
    setScore(scoreResponse); 
    setIsFetchingScore(false);
};

const handleResponseFetch = async () => {
  const prompt = `Cardname: ${openedCards}\nScenario: ${scenario}\nUser Input: ${userInput} and also give critically score for entered scenario and userinput and combining show overall score out of 10 under the response`; 
  setIsFetchingResponse(true);
  const responseData = await sendPromptToAPI(prompt, "response");
  setResponse(responseData);
  if (responseData) {
    speakResponse(responseData);
    socket.emit("updatePlayers", { email, scenario, userInput, response: responseData });
  }
  setIsFetchingResponse(false);
};

let utterance = null; // Store speech globally
let lastSpokenText = ""; // Store last spoken text

const speakResponse = (text) => {
  if ('speechSynthesis' in window) {
    if (utterance) {
      window.speechSynthesis.cancel(); // Stop any ongoing speech
    }

    utterance = new SpeechSynthesisUtterance(text);
    lastSpokenText = text; // Store text for resuming if needed

    if (/[\u0900-\u097F]/.test(text)) { 
      utterance.lang = "mr-IN";  
    } else {  
      utterance.lang = "en-US";  
    }

    utterance.rate = 1;  // Speed
    utterance.pitch = 1; // Pitch
    utterance.volume = 1; // Volume

    window.speechSynthesis.speak(utterance);
    setIsPaused(false); // Reset state
  } else {
    console.error("Speech synthesis not supported in this browser.");
  }
};

const toggleSpeech = () => {
  if (window.speechSynthesis.speaking) {
    if (isPaused) {
      window.speechSynthesis.resume();
    } else {
      window.speechSynthesis.pause();
    }
    setIsPaused(!isPaused);
  } else if (!isPaused && lastSpokenText) {
    // If speech is stopped, restart from the beginning
    speakResponse(lastSpokenText);
  }
};

useEffect(() => {
  const handleBeforeUnload = () => {
    window.speechSynthesis.cancel(); // Stop ongoing speech
  };  window.addEventListener("beforeunload", handleBeforeUnload);
  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, []);

const sendPromptToAPI = async (prompt, mode) => {
  try {
    const response = await fetch(API.OPENAI_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ prompt }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    const content = data.choices?.[0]?.message?.content || "No response";
    return content;
  } catch (err) {
    console.error("Error:", err.message);
    return "Error fetching data";
  }
};

//////////kalki analysis
const handleKalkiAnalysis = async () => {
  setIsFetchingAnalysis(true);

  const analysisPrompt = `Perform KALKI analysis based on the following:\n
  - **K**nowledge Insight: What knowledge is applied in this game?\n
  - **A**ssessment: How well did the user respond?\n
  - **L**ogical Insights: Analyze reasoning used.\n
  - **K**ey Takeaways: What lessons can be learned?\n
  - **I**mprovement Areas: How can the user do better?\n
  Scenario: ${scenario}
  User Input: ${userInput}
  Response: ${response}`;
  const analysisResponse = await sendPromptToAPI(analysisPrompt, "analysis");
  setAnalysis(analysisResponse);
  setIsFetchingAnalysis(false);
};

const handleKarmicAnalysis = async () => {
  setIsFetchingKarmicAnalysis(true);
  setShowKarmicAnalysis(true);  // ✅ Show analysis only after clicking

  const karmicanalysisPrompt = `To a Scenario: ${scenario}  what is the status? 
  for a card 'How would you implement laws that hold public officials accountable for their actions and punish corruption? 
  the User Input: ${userInput} is Budget / Expense will be shared soon. 
  Progress report being done... work in progress.  Do Karmic analysis using all religion with scores and lessons to learn including KALKI 
  also cover all global religions including Taoism, Native America.`;

  const karmicanalysisResponse = await sendPromptToAPI(karmicanalysisPrompt, "analysis");
  setKarmicAnalysis(karmicanalysisResponse);
  setIsFetchingKarmicAnalysis(false);
};

const handleCardFlip = (index) => {
  setFlippedCardIndex(index);
  setOpenedCards((prev) => {
      const newOpenedCards = [...prev];
      const selectedCard = cards[index];
      const isCardExists = newOpenedCards.some(card => card.cardname === selectedCard.cardname);
      if (!isCardExists) {
          newOpenedCards.push(selectedCard);
          speakResponse(`You have opened ${selectedCard.cardname} card`);
      }
      console.log("Opened Cards Updated:", newOpenedCards); 
      return newOpenedCards;
  });
};
  
  const uniqueCardGroups = [...new Set(cardGroups.map((group) => group.cardgroup))];

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleGameStart = () => {
    setGameCards([...openedCards]); 
    setGameStarted(true);
    setTimerActive(true);
    setSelectedCardGroup(null);
    setCards([]);
    setFlippedCardIndex(null);
  };

  const handleUserInput = (event) => {
    setUserInput(event.target.value); 
  };

  //////////scenario///////
  const handleScenario = (event) => {
    setscenario(event.target.value);
  
    if (isMultiplayer) {
      console.log("Emitting scenario:", event.target.value);
      socket.emit("sendScenario", { scenario: event.target.value, from: email });
    }
  };    

  const startListening = (field) => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
    recognition.onstart = () => {
      setIsListening(true);
    };
    recognition.onresult = (event) => {
    const transcript = event.results[0][0].transcript;
      // Check which field needs to be updated
      if (field === "scenario") {
        setscenario(transcript);
      } else if (field === "userInput") {
        setUserInput(transcript);
      }
    };
    recognition.onend = () => {
      setIsListening(false);
    };
    recognition.onerror = (event) => {
      console.error("Speech Recognition Error:", event.error);
      setIsListening(false);
    };
    recognition.start();
  };
  
  
  ///////////API'S Data Fetch//////// 
  useEffect(() => {
    const fetchGameCategories = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not available");
        return;
      }
      try {
        setLoading(true);
        const response = await axios.get(API.GET_GAME_CATEGORIES_API, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("API Response:", response.data);
        if (Array.isArray(response.data)) {
          setGameCategories(response.data);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching game categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGameCategories();
  }, []);  
    
  const handleCategoryChange = async (event) => {
    const category = event.target.value;
    setSelectedCategory(category);
    setLoadingNames(true);
    setGameNames([]); 
    try {
      const response = await axios.get(`${API.GET_GAME_NAMES_API}/${category}`);
      if (response.status === 200) {
        setGameNames(response.data.gamenames);
      } else {
        alert("No game names found for this category.");
      }
    } catch (error) {
      console.error("Error fetching game names:", error);
      alert("Failed to fetch game names.");
    } finally {
      setLoadingNames(false);
    }
  };  
  
  useEffect(() => {
    const fetchGamenames = async () => {
      try {
        const response = await axios.get(API.GET_GAME_NAMES_API);
        const uniqueNames = [
          ...new Map(response.data.map(item => [item.gamename, item])).values()
        ];       
        setGameCategories(uniqueNames);
      } catch (error) {
        console.error("Error fetching game names:", error);
      }
    }; 
    fetchGamenames();
  }, []);  

  const handleGamenameChange = async (event) => {
    const gamename = event.target.value;
    setSelectedGamename(gamename);
    setLoadingGroups(true);
    setCardGroups([]);
    setShowNotification(false); // Hide notification by default

    try {
        // Fetch Card Groups for Selected Game
        const response = await axios.get(`${API.GET_CARD_GROUPS_API}/${selectedCategory}/${encodeURIComponent(gamename)}`);
        if (response.status === 200) {
            setCardGroups(response.data.cardgroups);
        } else {
            alert("No card groups found for this game name.");
        }

        // ✅ Fetch Karmic Analysis Status
        const karmicResponse = await axios.get(API.GET_KARMIC_ANALYSIS(gamename));

        if (karmicResponse.status === 200) {
            const isKarmicYes = karmicResponse.data.karmic_analysis === "Yes";
            setKarmicAnalysis(isKarmicYes);
            if (isKarmicYes) {
                setShowNotification(true); // Show notification when "Yes"
            }
        } else {
            setKarmicAnalysis(false);
        }

    } catch (err) {
        console.error("Error fetching card groups or karmic analysis:", err);
        alert("Failed to fetch data.");
    } finally {
        setLoadingGroups(false);
    }
};

  useEffect(() => {
    const fetchCardNames = async () => {
      try {
        const response = await axios.get(API.GET_CARD_GROUPS_API);
        const uniqueCards = response.data.filter(
          (card, index, self) =>
            index === self.findIndex((c) => c.cardname === card.cardname)
        );
        setGameCategories(uniqueCards);
      } catch (error) {
        console.error("Error fetching card names:", error);
      }
    };
    fetchCardNames();
  }, []);

  const handleCardGroupCheckbox = async (e, selectedCardGroup) => {
    const isChecked = e.target.checked;
    setLoading(true);
    setSelectedCardGroups((prevSelected) => {
        let updatedGroups = isChecked
            ? [...prevSelected, selectedCardGroup]
            : prevSelected.filter(group => group !== selectedCardGroup);

        return updatedGroups;
    });
    try {
        await fetchCardsForGroups(e, selectedCardGroup);
    } catch (error) {
        console.error("Error fetching cards for groups:", error);
    } finally {
        setLoading(false); 
    }
};

const fetchCardsForGroups = async (e, selectedCardGroup) => {
  const isChecked = e.target.checked;
  setLoading(true);
  setSelectedCardGroups((prevSelected) => {
      if (isChecked) {
          return [...prevSelected, selectedCardGroup]; 
      } else {
          return prevSelected.filter((group) => group !== selectedCardGroup); 
      }
  });
  try {
      if (isChecked) {
          setCards([]);
          setFlippedCardIndex(null);
          const response = await axios.get(
              `${API.GET_CARD_NAMES_API}/${selectedCategory}/${selectedGamename}/${encodeURIComponent(selectedCardGroup)}`
          );
          console.log('Fetched Cards:', response.data);
          if (response.status === 200 && response.data?.cards?.length > 0) {
              setCards(response.data.cards);
          } else {
              alert("No cards found for this group.");
          }
      }
  } catch (err) {
      console.error("Error fetching cards:", err);
      alert("Failed to fetch cards.");
  } finally {
      setLoading(false);
  }
};

  useEffect(() => {
    const fetchCardnames = async () => {
      try {
        const response = await axios.get(API.GET_CARD_NAMES_API);
        const uniqueNames = [
          ...new Map(response.data.map(item => [item.gamename, item])).values()
        ];        
        setGameCategories(uniqueNames);
      } catch (error) {
        console.error("Error fetching game names:", error);
      }
    };
    fetchCardnames();
  }, []); 

  useEffect(() => {
    let interval;
    if (timerActive) {
      interval = setInterval(() => {
        setTimeElapsed((prevTime) => prevTime + 1);
      }, 1000); // Increment every second
    }
    return () => clearInterval(interval);
  }, [timerActive]);

  const handleGameOver = () => {
    window.location.reload(); 
  };

///////////db submission///////////
const handleGameSubmit = async () => {
  setTimerActive(false);
  const finalTime = timeElapsed;
  if (selectedCardGroups.length === 0) {
      alert("Please select at least one card group before submitting.");
      return;
  }
  const dataToSubmit = {
      score,  
      email,
      selectedCategory,
      selectedGamename,
      selectedCardGroups, 
      openedCards,
      scenario,
      userInput,
      response,
      timeElapsed: finalTime,
      analysis,
  };
  console.log("Submitting data:", dataToSubmit);
  try {
      const res = await axios.post(API.POST_PLAY_API, dataToSubmit);
      if (res.status === 200 || res.status === 201) {
          alert("Data submitted successfully!");
          setOpenedCards([]);
          setscenario("");
          setUserInput("");
          setGameStarted(false);
          setTimerActive(false);
          setTimeElapsed(0);
          setScore(0);
          setResponse("");
          setShowGameOver(true);
      } else {
          alert("Failed to submit data.");
      }
  } catch (error) {
      console.error("Error submitting data:", error);
      alert("Failed to submit data.");
  }
};

const handleRefresh = () => {
setSelectedCategory(null);
setSelectedGamename(null);
setOpenedCards([]);
setscenario("");  
setUserInput("");
setGameStarted(false);
setTimerActive(false);
setTimeElapsed(0);
setScore(0);
setCardGroups([]);
setGameCategories([]);
setGameNames([]);
setLoading(true); 
setLoadingNames(true); 
setLoadingGroups(true); 

window.location.reload();
};
    
  return (
    <div className="flex min-h-screen bg-black">
      {/* Sidebar for Categories */}
      <div className="w-1/5 bg-gray-800 text-white p-4"> 

  <div className="mt-6 mb-6 relative">
  <button
    onClick={handleRefresh}
    className="bg-[#e64a32] text-white px-4 py-2 rounded-lg hover:bg-[#e64a32] focus:outline-none absolute top-0 right-0"
  >  Refresh </button>
</div>

<div>
<div className="mt-12"> 
  <h2 className="text-lg font-bold mb-4">Game Categories</h2>
  {loading ? (
    <p className="text-gray-500">Loading categories...</p>
  ) : (
    <select
      value={selectedCategory || ""}
      onChange={handleCategoryChange}
      className="w-full bg-white text-black px-4 py-2 rounded-lg mb-3"
    >
      <option value="" disabled>
        {gameCategories.length > 0 ? "Select a Category" : "No Categories Available"}
      </option>
      {gameCategories.map((category, index) => (
        <option key={index} value={category.gamecategory}>
          {category.gamecategory}
        </option>
      ))}
    </select> )}
</div>

        {/* Game Names */}
        {selectedCategory && !loadingNames && (
          <div>
            <h2 className="text-lg font-bold mt-6">Game Names</h2>
            {loadingNames ? (
              <p className="text-gray-500 mt-4">Loading game names...</p>
            ) : (
              <select
                value={selectedGamename || ""}
                onChange={handleGamenameChange}
                className="w-full bg-white text-black px-4 py-2 rounded-lg mb-3"
              >
                <option value="">Select a Game Name</option>
                {gameNames.map((name) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}

        {showNotification && (
          <div className="bg-yellow-400 text-black p-2 rounded-lg flex items-center justify-between">
            <span>⚡ It has Karmic Analysis</span>
            <button onClick={() => setShowNotification(false)} className="text-black font-bold">
              ✖
            </button>
          </div>
        )}

      {selectedGamename && !loadingGroups && (
        <div>
          <h2 className="text-lg font-bold mt-6">Card Groups</h2>
          {loadingGroups ? (
            <p className="text-gray-500 mt-4">Loading card groups...</p>
          ) : (
            <div className="bg-white p-2 rounded-md border text-black">
              {cardGroups.map((group, index) => (
                <div key={index} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id={`cardGroup-${index}`}
                    value={group}
                    onChange={(e) => handleCardGroupCheckbox(e, group)} // Call updated handler
                    className="cursor-pointer"/>
                  <label htmlFor={`cardGroup-${index}`} className="cursor-pointer">
                    {group}
                  </label>      </div>
              ))}
            </div>
          )}
        </div>
      )}

{openedCards.length > 0 && (
    <div className="mt-6">
   <button
      onClick={handleGameStart}
      className="w-full bg-white text-black px-4 py-2 rounded-lg hover:bg-gray-300 focus:outline-none animate-pulse"
    > Game Begins
    </button>
      {gameStarted && timerActive && (
        <div className="game-started mt-4">
          <h3 className="text-lg font-semibold">Game Started!</h3>
          <p className="text-sm">Total Time Taken: {timeElapsed} seconds</p>
        </div>
      )}
     </div>
     )}

  <div>
     {gameStarted && (
        <div className="mt-4">
       <div>
  <h3 className="text-lg font-semibold text-white mb-2">Enter Scenario</h3>
  <div className="relative">
    <textarea
      className="mt-2 p-2 border rounded w-full h-20 text-black pr-10"
      placeholder="Enter scenario"
      value={scenario}
      onChange={handleScenario}
    ></textarea>

    {/* Mic Button */}
    <button
      onClick={startListening}
      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-blue-500 z-50"
    >
      <Mic className={isListening ? "text-[#e64a32] animate-pulse" : ""} />
    </button>
  </div>  

  {/* Instruction Message */}
  {showPopup && (
    <p className="mt-2 text-yellow-400">Click the arrow to send your scenario to the chat.</p>
  )}
 
      <button 
        onClick={handleArrowClick}
        className="text-gray-600 hover:text-blue-500"
      >
        <ArrowRight className="w-8 h-8 text-yellow-400" />
      </button>
    </div>

        <div>
        <h4 className=" mt-4 text-lg font-semibold text-white mb-2">Enter User Input</h4>
        <div className="relative">
          <textarea
            className="mt-2 p-2 border rounded w-full h-20 text-black pr-10"
            placeholder="Enter input message"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
          ></textarea>
          <button
            onClick={() => startListening("userInput")}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-blue-500"  >
            <Mic className={isListening ? "text-[#e64a32] animate-pulse" : ""} />
          </button>
        </div>
      </div>

        <div>
          <button
            className="mt-4 px-4 py-2 bg-[#e64a32] text-white rounded hover:bg-[#e64a32] focus:outline-none"
            onClick={handleResponseFetch}
            disabled={isFetchingResponse || !openedCards || !scenario || !userInput}  >
            {isFetchingResponse ? "Loading..." : "Get Response"}
          </button>
      </div>

      {/* Display the Score */}
      <div className="mt-4">
          <button
            onClick={handleFetchScore}
            className="p-2 bg-[#e64a32] text-white rounded mb-4"
            disabled={isFetchingScore}  >
            {isFetchingScore ? "Loading..." : "Score"}
          </button>
      </div>

      {/* ////////////////KALKI Analysis///////////// */}
      <div className="mt-4">
        <button
          onClick={handleKalkiAnalysis}
          className="p-2 bg-[#e64a32] text-white rounded mb-4"
          disabled={isFetchingAnalysis || !scenario || !userInput || !response}
        >
          {isFetchingAnalysis ? "Analyzing..." : "Kalki Analysis"}
        </button>
      </div>

     {/* Show Karmic Analysis button only if game has started and Karmic Analysis is "Yes" */}
      {gameStarted && karmicAnalysis && (
        <div className="mt-4">
          <button
            onClick={handleKarmicAnalysis}
            className="p-2 bg-[#e64a32] text-white rounded mb-4"
            disabled={isFetchingKarmicAnalysis || !scenario || !userInput || !response}
          >
            {isFetchingKarmicAnalysis ? "Analyzing..." : "Karmic Analysis"}
          </button>
        </div>
      )}
      
          {/* Submit Button */}
    <div className="mt-4">
      <button
        onClick={handleGameSubmit}
        className="w-full bg-[#e64a32] text-white px-4 py-2 rounded-lg hover:bg-[#e64a32] focus:outline-none"
      >
        Submit
      </button>
    </div>
            </div>
          )}

      {/* Display Game Over message after Submit */}
      {!timerActive && score > 0 && (
        <div className="game-over mt-4">
          <h3 className="text-lg font-semibold">Game Over!</h3>
          <p className="text-sm">Total Time Taken: {timeElapsed} seconds</p>
        </div>
      )}
    </div>
            </div>

            {showGameOver && (
            <div className="mt-4">
              <button
                onClick={handleGameOver}
                className="w-full bg-[#e64a32] text-white px-4 py-2 rounded-lg hover:bg-[#e64a32] focus:outline-none"    >
                Game Over
              </button>
            </div>
          )}
          </div>
      
        {/* Main Content Area */}
        <div className="flex-1 flex flex-col items-center justify-start p-6 min-h-screen bg-black">
        <div className="absolute right-0 top-0 mt-8 mr-8 w-80">
      <div className="mb-6">
        <label htmlFor="email" className="block text-lg font-medium text-gray-700">
          Email Address
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={email} 
          className="mt-1 p-2 w-full border border-white rounded-md text-lg text-gray-800"
          readOnly
        />
      </div>
    </div>

      <h2 className="text-xl font-bold text-white mt-8 mb-8">Let's Play The Game !!</h2>
      <div>
      {console.log("Chat button visibility:", chatOpen)}
      <button onClick={toggleChat} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
        🗨️ Chat
    </button> 
{chatOpen && (
  <div className="chat-container bg-gray-900 text-white p-4 rounded-lg w-80 fixed top-16 right-0">
  <h3 className="text-lg font-bold mb-2">Chat</h3>

  {/* Online Users List */}
  <div className="mb-2">
      <h4 className="text-sm">Online Users:</h4>
      <ul className="text-sm">
          {onlineUsers.map((user) => (
              <li
                  key={user.email}
                  onClick={() => setSelectedReceiver(user.email)}
                  className={`cursor-pointer px-2 py-1 rounded-lg ${
                      selectedReceiver === user.email ? "bg-blue-500" : "hover:bg-gray-700"
                  }`}
              >
                  {user.email}
              </li>
          ))}
      </ul>
  </div>

  {/* Chat Messages */}
  <div className="chat-messages h-60 overflow-y-auto mb-2 p-2 border border-gray-700 rounded-lg">
      {messages.map((msg, index) => (
          <div
              key={index}
              className={`mb-2 p-2 rounded-lg max-w-[75%] ${
                  msg.sender === email ? "bg-blue-500 text-white ml-auto text-right" : "bg-gray-700 text-left"
              }`}
          >
              <p className="text-sm font-semibold">{msg.sender}</p>
              <p className="text-md">{msg.text}</p>
          </div>
      ))}
  </div>

  {/* Chat Input Box */}
  <div className="flex">
      <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Type a message..."
          className="flex-1 p-2 border rounded-lg text-black"
      />
      <button
          onClick={sendMessage}
          className="ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg"
      >
          Send
      </button>
  </div>
</div>
)}
 </div>

      {/* Show Loading or Cards */}
      {cards.length > 0 ? (
  <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4 mt-6">
    {cards.map((card, index) => (
      <div
        className="scene"
        style={{ perspective: "1000px" }}
        key={index}
        onClick={() => handleCardFlip(index)}  >
        <motion.div
          className="card"
          style={{
            width: "200px",
            height: "300px",
            position: "relative",
            transformStyle: "preserve-3d",
            transition: "transform 1s",
            cursor: flippedCardIndex === null ? "pointer" : "not-allowed",
            transform: flippedCardIndex === index ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front of the card */}
          <motion.div
            className="card_face card_face--front"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              backgroundColor: "#ffffff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3 className="text-sm font-sm text-gray-800">Click on the card</h3>
          </motion.div>

          {/* Back of the card */}
          <motion.div
            className="card_face card_face--back"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              transform: "rotateY(180deg)",
              backgroundColor: "#ffffff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={probingImage}
              alt="Shared Image"
              style={{
                width: "150%",
                maxWidth: "150px",
                marginBottom: "10px",
                height: "100%",
              }}
            />
            <h3 className="text-sm font-bold text-gray-800">
              {card || 'Card Name Missing'}
            </h3>
          </motion.div>
        </motion.div>
      </div>
    ))}
  </div>
) : (
  <p className="text-gray-500 mt-4">No cards available.</p>
)}

      {/* Opened Cards Section */}
<div className="mt-4">
  {openedCards.length > 0 && (
    <div className="w-full bg-gray-900 text-white p-4 mb-6 rounded-lg">
      <h3 className="text-lg font-bold mb-2">Opened Cards:</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {openedCards.map((card, index) => (
          <div className="scene" style={{ perspective: "1000px" }} key={index}>
            <motion.div
              className="card"
              style={{
                width: "200px",
                height: "300px",
                position: "relative",
                transformStyle: "preserve-3d",
                transition: "transform 1s",
                transform: "rotateY(180deg)", 
              }}
            >
              <motion.div
                className="card_face card_face--back"
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backfaceVisibility: "hidden",
                  transform: "rotateY(180deg)",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  src={probingImage}
                  alt="Shared Image"
                  style={{
                    width: "150%",
                    maxWidth: "150px",
                    marginBottom: "10px",
                    height: "100%",
                  }}
                />
                <h3 className="text-sm font-bold text-gray-800">
                  {typeof card === "object" ? card.cardname : card || 'Card Name Missing'}
                </h3>
              </motion.div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  )}
</div>
   
   {/* Response Section */}
   {response && (
        <div className="w-full bg-white text-black p-4 mb-6 rounded-lg text-xl">
          <h3 className="text-lg font-bold mb-2">Response:</h3>
          <p className="text-lg text-black">{response}</p>

          <div className="mt-2">
            <button 
              onClick={toggleSpeech} 
              className="px-4 py-2 bg-gray-600 text-white rounded-lg mx-2">
              {isPaused ? "Resume" : "Pause"}
            </button>
          </div>
        </div>
      )}

     {/* Score Response Section */}
   {score && (
      <div className="w-full bg-white text-black p-4 mb-6 rounded-lg text-xl">
        <h3 className="text-lg font-bold mb-2">Score:</h3>
        <p className="text-md text-black">{score}</p>
      </div>
    )}

    {/* kalki analysis */}
    {analysis && (
      <div className="w-full bg-white text-black p-4 mb-6 rounded-lg text-xl">
        <h3 className="text-lg font-bold mb-2">Kalki Analysis:</h3>
        <p className="text-md text-black">{analysis}</p>
      </div>
    )}

{/* karmic analysis */}
{showKarmicAnalysis && karmicAnalysis && (
  <div className="w-full bg-white text-black p-4 mb-6 rounded-lg text-xl">
    <h3 className="text-lg font-bold mb-2">Karmic Analysis:</h3>
    <p className="text-md text-black">{karmicAnalysis}</p>
  </div>
)}



    {/* Error Section */}
    {error && (
      <div className="w-full bg-red-900 text-white p-4 mb-6 rounded-lg">
        <h3 className="text-lg font-bold mb-2">Error:</h3>
        <p className="text-md text-red-300">{error}</p>
      </div>
    )}

{playersData.length > 0 && (
  <div className="mt-6 w-full">
    <h2 className="text-lg font-bold text-white mb-4">All Players' Responses</h2>
    <table className="min-w-full border-collapse border border-gray-500">
      <thead>
        <tr className="bg-gray-700 text-white">
          <th className="border border-gray-500 px-4 py-2">Email</th>
          <th className="border border-gray-500 px-4 py-2">Scenario</th>
          <th className="border border-gray-500 px-4 py-2">User Input</th>
          <th className="border border-gray-500 px-4 py-2">Response</th>
        </tr>
      </thead>
      <tbody>
        {playersData.map((player, index) => (
          <tr key={index} className="text-white bg-gray-800">
            <td className="border border-gray-500 px-4 py-2">{player.email}</td>
            <td className="border border-gray-500 px-4 py-2">{player.scenario}</td>
            <td className="border border-gray-500 px-4 py-2">{player.userInput}</td>
            <td className="border border-gray-500 px-4 py-2">{player.response}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}
    </div>
  </div> 
  );
};

export default CardScenario;
